import IModel from "@/models/IModel";

export interface IMailQueueAdminSimple extends IModel {
	createdAt: Date;
	sentAt: Date;
	errorMessage?: string;
	state: MailQueueEntryState
	subject: string;
	recipients: string[];
	sender: string;
}

export interface IMailQueueAdminListEntry extends IMailQueueAdminSimple {
}

export interface IMailQueueAdmin extends IMailQueueAdminListEntry {

}

export interface IMailQueueAdminEntryFilter {
	state: MailQueueEntryState | null;
}


export enum MailQueueEntryState {
	mailQueueEntryCreated = 0,
	mailQueueEntrySending = 10,
	mailQueueEntrySent = 100,
	mailQueueEntryError = 200,
	mailQueueEntryDiscarded = 300,
}